module.exports = __webpack_public_path__ + "static/media/akira2.97a70869.png";